export const POPUP_OPEN_TYPE = {
	CLOSED: 'CLOSED',
	NORMAL: 'NORMAL',
	MINIMIZED: 'MINIMIZED',
};

export const CHAT_BG_TYPE = {
	VIDEO: 'VIDEO',
	IMAGE: 'IMAGE',
	GRADIENT: 'GRADIENT',
	SOLID: 'SOLID',
};

export const BADGE_TYPE = {
	MINI: 'MINI',
	SMALL: 'SMALL',
	MEDIUM: 'MEDIUM',
	LARGE: 'LARGE',
};

export const SCREEN_TYPE = {
	LAUNCH: 'LAUNCH',
	CHAT: 'CHAT',
};

export const MENU_OPTION_TYPE = {
	PATH: 'postback',
	URL: 'web_url',
	CALLBACK: 'callback',
};

export const FAQ_AUTOCOMPLETE_OPTION_TYPE = {
	PATH: '',
	URL: '',
	CALLBACK: 'callback',
};

export const HEADER_TYPE = {
	TEXT_WITH_IMAGE: 'TEXT_WITH_IMAGE',
	IMAGE: 'IMAGE',
};

export const BUTTON_TYPE = {
	BASE: 'base',
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	TERTIARY: 'tertiary',
	MINI: 'mini',
};

export const FONT_SIZE = {
	SMALL: 'sm',
	MEDIUM: 'md',
	LARGE: 'lg',
};

export const BUTTON_SIZE = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
};

export const CARD_TYPE = {
	THIN: 'thin',
	SMALL: 'small',
	MEDIUM: 'medium',
};

export const CAROUSEL_TYPE = {
	SINGLE_INLINE_DOT: 'SINGLE_INLINE_DOT',
	STACKED_INLINE_DOT: 'STACKED_INLINE_DOT',
	STACKED_SEPARATED_DOT: 'STACKED_SEPARATED_DOT',
	VERTICAL_LIST: 'VERTICAL_LIST',
	VERTICAL_CONTINUOUS_SCROLL_SEAMLESS: 'VERTICAL_CONTINUOUS_SCROLL_SEAMLESS',
	VERTICAL_SHOW_ONE_SEAMLESS: 'VERTICAL_SHOW_ONE_SEAMLESS',
	VERTICAL_SHOW_ONE_LIST: 'VERTICAL_SHOW_ONE_LIST',
	VERTICAL_SHOW_ONE_SEPARATE: 'VERTICAL_SHOW_ONE_SEPARATE',
	VERTICAL_CONTINUOUS_SCROLL_SEPARATE: 'VERTICAL_CONTINUOUS_SCROLL_SEPARATE',
	HORIZONTAL_SHOW_ONE_SEAMLESS: 'HORIZONTAL_SHOW_ONE_SEAMLESS',
	HORIZONTAL: 'HORIZONTAL',
	VERTICAL: 'VERTICAL',
};

export const CARD_ACTION_TYPE = {
	FAQ: 'FAQ',
	PATH: 'PATH',
	URL: 'URL',
	WEB_URL: 'WEB_URL',
	POSTBACK: 'POSTBACK',
	PHONE_NUMBER: 'PHONE_NUMBER',
};

export const DATA_ICON_STATUS = {
	IS_HOVERED: 'data-rating-hover',
	IS_SELECTED: 'data-rating-selected',
	SELECTED_INDEX: 'data-rating-index',
	IS_DISABLED: 'data-rating-disabled',
};

export const POPOVER_ROLE = {
	ELLIPSIS: 'ELLIPSIS',
	TOOLTIP: 'TOOLTIP',
	EXPANDABLE: 'EXPANDABLE',
};

export const MESSAGE_SENDER = {
	BOT: 'bot',
	USER: 'user',
	AGENT: 'agent',
};

export const MESSAGE_TYPE = {
	AUTOCOMPLETE: 'autocomplete',
	TEXT: 'text',
	TIMESTAMP: 'time',
	AGENT_PARTICIPATION_STATUS: 'AGENT_PARTICIPATION_STATUS',
	CAROUSEL: 'CAROUSEL',
	OPTIONS: 'options',
	IDENTITY: 'identity',
	FEEDBACK: 'feedback',
	STATUS_DIVIDER: 'divider',
	IMAGE: 'image',
	FILE: 'file',
	VIDEO: 'video',
	AUDIO: 'audio',
	TYPING_INDICATOR: 'typing_indicator',
	SLIDER: 'SLIDER',
	MAINTENANCE: 'MAINTENANCE',
	COPY_TO_CLIPBOARD: 'COPY_TO_CLIPBOARD',
	CALL_REQUEST: 'CALL_REQUEST',
	WEB_VIEW: 'WEB_VIEW',
	FILE_RECEIVED: 'file_received',
	SKIP: 'skip',
	UPDATE_LIVECHAT_STATUS: 'UPDATE_LIVECHAT_STATUS',
	CUSTOM_CARD: 'CARD',
	THINKING_INDICATOR: 'thinking_indicator',
	LLM_STREAM: 'LLM_STREAM',
	ASK_USER_NAME: 'ASK_USER_NAME',
};

export const MESSAGE_TEXT_INPUT_TYPE = {
	DATE: 'date',
	FILE: 'file',
	PASSWORD: 'password',
};

export const MESSAGE_ACTION = {
	TYPING_ON: 'typing_on',
	THINKING: 'thinking',
};
export const NODE_TYPES = {
	IDENTITY: 'IDENTITY_NODE',
	FEEDBACK_NODE: 'FEEDBACK_NODE',
	RCV_INP: 'RCV_INP',
	FORM_NODE: 'FORM_NODE',
	SEND_CAROUSEL: 'SEND_CAROUSEL',
};

export const FILE_TYPES = {
	docx: 'DOCX',
	doc: 'DOCX',
	txt: 'TXT',
	ppt: 'PPT',
	pptx: 'PPT',
	csv: 'CSV',
	zip: 'ZIP',
	pdf: 'PDF',
	xls: 'XLS',
	jpg: 'JPG',
	jpeg: 'JPG',
	png: 'PNG',
};

export const VOICE_MODE = {
	INPUT: 'input',
	LISTENING: 'listening',
	PROCESS_INPUT: 'processing_input',
	WAIT_FOR_RESPONSE: 'waiting_for_response',
	SPEAKING: 'speaking',
	EXISTING_VOICE: 'exiting_voice',
};

export const SLIDER_TYPES = {
	PERCENTAGE: 'PERCENTAGE',
	NUMBER: 'NUMBER',
	RATING: 'RATING',
};

export const BOT_MODE = {
	WIDGET: 'WIDGET',
	STANDALONE: 'STANDALONE',
};

export const CHAT_SETTINGS = {
	FONT_SIZE: 'engtFontSize',
	LANGUAGE_PREFERENCE: 'engtLanguagePreference',
};

export const VIDEO_TYPES = {
	VIMEO: 'vimeo',
	YOUTUBE: 'youtube',
	FACEBOOK: 'facebook',
	VIDEO: 'video',
};
